module.exports = __webpack_public_path__ + "files/a79615e6aee228b3b80f03740299d0e4.ttf";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/google-fonts/fonts/lato-bolditalic-webfont.ttf
// module id = 834
// module chunks = 60